import React from 'react';
import { PlayerEvent } from '@smart-tv/components/player/types';
import { usePlayerContext } from '../_contexts/player-context';

let instanceCounter = 0;

export const usePlayerEvent = (eventName: PlayerEvent, handler: (event: any) => void) => {
  const storedHandler = React.useRef(handler);
  const instanceId = React.useRef<number>();

  if (instanceId.current === undefined) {
    instanceId.current = ++instanceCounter;
  }

  const { player } = usePlayerContext();

  React.useEffect(() => {
    storedHandler.current = handler;
  }, [handler]);

  React.useEffect(() => {
    if (!player) return;

    const eventListener = (voEvent: Event) => {
      storedHandler.current?.(voEvent);
    };

    player.addEventListener(eventName, eventListener);

    return () => {
      player.removeEventListener(eventName, eventListener);
    };
  }, [eventName, player]);
};

export default usePlayerEvent;
